import logo from './logo.svg';
import './App.css';

import Upload from './app/Upload';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Upload />
      </header>
    </div>
  );
}

export default App;
